export default "__VITE_ASSET__2b0ac434__"